import { merge } from 'lodash'

import { urqlClubOffline } from './urqlClubOffline'
import { urqlExerciseOffline } from './urqlExerciseOffline'

export const urqlOfflineCache = merge(urqlExerciseOffline, urqlClubOffline)
